import React from "react";
import { Box } from "theme-ui";
import { Checkbox } from "antd";

export const CheckboxControl: React.FC<any> = ({ value, label, onChange }) => {
  return (
    <>
      <Checkbox checked={value} onChange={(ev) => onChange(ev.target.checked)} />
      <Box as="span" ml={2}>{label}</Box>
    </>
  );
};
